import styled, { css } from "styled-components";

export const Axis = styled.g<{ isXAxis?: boolean }>`
  .domain,
  .tick line {
    display: none;
  }

  .tick text {
    stroke-width: 0.5;
    font-size: 10px;
    font-weight: 600;
    line-height: 22px;
    fill: #98a0ab;
  }

  ${({ isXAxis }) =>
    !isXAxis &&
    css`
      g.tick {
        text-anchor: start;
        &:first-of-type {
          visibility: hidden;
        }
      }
    `}
`;

export const RoundColor = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 360px;
  background: ${p => p.color};
`;

export const Text = styled.text`
  font-family: "Open sans", sans-serif;
  font-size: 8px;
  text-anchor: start;
`;

export const Svg = styled.svg`
  height: max-content;
  width: 100%;
  cursor: crosshair;
  user-select: none;
  .tick {
    font-family: "Open sans", sans-serif;
  }
  .new-day-start {
    fill: var(--menu-ebony-light-color, var(--ebony-light)) !important;
  }
`;

export const Brush = styled.g<{ $pointerEvent: string }>`
  .overlay {
    pointer-events: ${({ $pointerEvent }) => $pointerEvent};
    cursor: pointer;
  }

  .selection {
    fill: rgba(71, 134, 255, 0.16);
    stroke: transparent;
    fill-opacity: 1;
  }
`;
